import { formatInTimeZone } from 'date-fns-tz';
import type { IntelSummary } from 'design-system';

import { http } from '@/services/http';

import type { SignalEvent, SignalsResponse } from '../types/marketEvents.types';

const toTitleCase = (value: string): string =>
  value.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

// generated_at has no timezone marker; backend sends it in UTC.
const formatTimestamp = (generatedAt: string): string =>
  formatInTimeZone(`${generatedAt}Z`, 'UTC', "d MMM, HH:mm 'UTC'");

const toIntelSummary = (event: SignalEvent): IntelSummary => ({
  id: event.id,
  title: event.symbols.map(symbol => symbol.name).join(' vs ') || toTitleCase(event.event_type),
  importance: event.importance,
  region: toTitleCase(event.event_type),
  timestamp: formatTimestamp(event.generated_at),
  blurb: event.interpretation
});

export const fetchMarketEvents = async (): Promise<IntelSummary[]> => {
  const { data } = await http.internal.get<SignalsResponse>('/signals?recent=true');
  const items = Array.isArray(data?.items) ? data.items : [];
  return items.map(toIntelSummary);
};
